class ProductOptions extends HTMLElement {
  constructor() {
    super();
    this.handleCardClick = this.handleCardClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleCardClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleCardClick);
  }

  async handleCardClick(event) {
    if (!event.target.closest('.product-single__image-variant-wrapper')?.classList.contains('custom-bundle')) {
      event.preventDefault();
    }

    const target = event.target.closest('.product-single__image-variant');

    if (!target || !target.href || target.classList.contains('active')) return;

    const url = target.href;

    this.updateActiveCard(target);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Load error: ${response.status}`);

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('.wrapper-product');

      if (newContent) {
        const currentContent = document.querySelector('.wrapper-product');
        currentContent.replaceWith(newContent);
        window.history.pushState({}, '', url);

        if (typeof ajaxCart !== 'undefined') {
          ajaxCart.load();
        }

        if (ajaxCart.init && typeof ajaxCart.init === 'function') {
          ajaxCart.init({
            formSelector: '[data-product-form]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '${{amount}}',
            disableAjaxCart: false,
            enableQtySelectors: true
          });
        }

        initializeQuantitySync();

        this.reinitializeScripts(newContent, 'data-buybox-init');
        this.reinitializeScripts(doc, 'data-theme-js');
        this.reinitializeScripts(doc, 'data-jdgm-script');

        document.querySelector('.easylockdown-content').style.display = 'unset';
      }
    } catch (error) {
      console.error('Update content error:', error);
    } finally {
      document.querySelector('product-options').click();
      setTimeout(() => {
        document.querySelector('product-options').click();
      }, 500);
    }
  }

  updateActiveCard(activeCard) {
    const cards = this.querySelectorAll('.product-single__image-variant');
    cards.forEach(card => card.classList.remove('active'));
    activeCard.classList.add('active');
  }

  reinitializeScripts(doc, dataAtr) {
    const script = doc.querySelector(`script[${dataAtr}]`);
    if (script) {
      try {
        const newScript = document.createElement('script');

        Array.from(script.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });

        if (script.textContent) {
          newScript.textContent = script.textContent;
        }

        document.querySelectorAll(`script[${dataAtr}]`).forEach(el => {
          el.remove();
        })

        document.body.appendChild(newScript);
      } catch (error) {
        console.error('Failed to reinitialize script:', error);
      }
    }
  }
}

customElements.define('product-options', ProductOptions);

function initializeQuantitySync() {
  const metaQtyInput = document.querySelector('.product-single__meta .js-qty__num');
  const stickyQtyInput = document.querySelector('.product-single__sticky-add .js-qty__num');

  if (!metaQtyInput || !stickyQtyInput) {
    return;
  }

  const metaPriceElement = document.querySelector('.product-single__meta #ProductPrice');
  const stickyPriceElement = document.querySelector('.product-single__sticky-add #ProductPrice');

  if (!metaPriceElement || !stickyPriceElement) {
    return;
  }

  const metaComparePriceElement = document.querySelector('.product-single__meta #ComparePrice');
  const stickyComparePriceElement = document.querySelector('.product-single__sticky-add #ComparePrice');

  const basePrice = parseFloat(metaPriceElement.getAttribute('content'));
  const baseComparePrice = metaComparePriceElement
    ? parseFloat(metaComparePriceElement.textContent.replace(/[^0-9.-]+/g, ''))
    : null;

  if (isNaN(basePrice)) {
    return;
  }

  const updatePrice = (quantity) => {
    const newPrice = (basePrice * quantity).toFixed(2);
    metaPriceElement.textContent = `$${newPrice}`;
    stickyPriceElement.textContent = `$${newPrice}`;

    metaPriceElement.setAttribute('content', newPrice);
    stickyPriceElement.setAttribute('content', newPrice);

    if (baseComparePrice) {
      const newComparePrice = (baseComparePrice * quantity).toFixed(2);
      metaComparePriceElement.textContent = `$${newComparePrice}`;
      stickyComparePriceElement.textContent = `$${newComparePrice}`;
    }
  };

  const syncValues = (source, target) => {
    if (source.value !== target.value) {
      target.value = source.value;
    }
    updatePrice(parseInt(source.value, 10));
  };

  const setupButtonListeners = (container, sourceInput, targetInput) => {
    const buttons = container.querySelectorAll('.js-qty__adjust');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => syncValues(sourceInput, targetInput), 0);
      });
    });
  };

  const setupMutationObserver = (sourceInput, targetInput) => {
    const observer = new MutationObserver(() => {
      syncValues(sourceInput, targetInput);
    });
    observer.observe(sourceInput, { attributes: true, attributeFilter: ['value'] });
  };

  const metaContainer = document.querySelector('.product-single__meta .js-qty');
  const stickyContainer = document.querySelector('.product-single__sticky-add .js-qty');

  if (metaContainer && stickyContainer) {
    setupButtonListeners(metaContainer, metaQtyInput, stickyQtyInput);
    setupButtonListeners(stickyContainer, stickyQtyInput, metaQtyInput);

    setupMutationObserver(metaQtyInput, stickyQtyInput);
    setupMutationObserver(stickyQtyInput, metaQtyInput);

    updatePrice(parseInt(metaQtyInput.value, 10));
  }
}

document.addEventListener('DOMContentLoaded', initializeQuantitySync);
